// Entities Reducers:

export const REDUCER_NAME_FEEDBACK_FORMS = 'feedbackForms'
